import {PaginatedRequest} from "../../models/core/paginated.request";
import {PaginatedResult} from "../../models/core/paginated.result";
import {StatementFile} from "../../models/accounting/client-statements";
import {AxiosInstance} from "axios";
import API from "../../utils/api";

export class StatementsFilesService {
    api: AxiosInstance = API;

    public async getAllByAccount(request: PaginatedRequest, accountId: number): Promise<PaginatedResult<StatementFile>> {
        request.addFilter("account", accountId.toString());
        return (await this.api.get<PaginatedResult<StatementFile>>(
            "accounting/statements-files",
            {
                params: request.toParams()
            }
        )).data;
    }

    public reload = (item: StatementFile): Promise<any> => {
        return this.api.post("accounting/statements-files/" + item.id + "/reload");
    }
}

export const statementsFilesService = new StatementsFilesService();